<gast-overlay-spinner [text]="'COMMON.SPINNER_TEXT' | translate"></gast-overlay-spinner>
<div class="viewport">
  <gast-portal-header [model]="headerModel" [style]="headerStyle" [user]="getUserModel()" (loginPressed)="login()"
    (logoutPressed)="logout()" (logoPressed)="logoPressed()" (languageChanged)="changeLanguage($event)">
  </gast-portal-header>

  <div class="container" style="margin-top:3rem;">
    <router-outlet></router-outlet>
  </div>

  <gast-portal-floating-contact-panel [model]="floatingContactPanelModel">
  </gast-portal-floating-contact-panel>
</div>

<gast-portal-footer [model]="footerModel">
</gast-portal-footer>
